__turbopack_context__.v({
  "arrow": "-OeWUG_arrow",
  "dropdown": "-OeWUG_dropdown",
});
